<template>
    <v-dialog
        v-model="showDialog"
        max-width="600px"
        min-heigth="600px"
        scrollable
        >
        <v-card  style="background-color:#f7f7f7">
            <v-toolbar
              class="elevation-3"
              color="primary"
              dark
            >
                <v-toolbar-title>
                    Buscar perfil
                </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn
                icon
                @click="showDialog = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text >
                <v-text-field
                    v-model="textSearchContact"
                    label="Buscar contacto"
                    :append-outer-icon="
                      textSearchContact
                        ? 'mdi-close'
                        : 'mdi-account-search'
                    "
                    @click:append-outer="
                      textSearchContact
                        ? cancelSearch()
                        : loadContacts()
                    "
                    v-on:keydown="loadContacts()"
                  ></v-text-field>
            </v-card-text>
            <v-card-text>
                <v-col
                  cols="12"
                  style="max-height: 400px"
                  class="overflow-y-auto"
                  @scroll="handleScrollContacts"
                  v-if="contactsFiltered.length != 0"
                >
                  
                  <v-card class="mx-auto">
                    <v-list>
                      <v-list-item-group>
                        <div
                          v-for="(data, letter) in contactsFiltered"
                          :key="letter"
                        >
                          <v-subheader>{{ letter }}</v-subheader>
                          <div v-for="(person, index) in data" :key="index">
                            <v-list-item
                              @click="openProfile(person.IDStB, person.tipo_usuario)"
                              v-if="person.IDStB !== user.IDStB"
                            >
                              <v-list-item-avatar>
                                <v-img
                                  :src="person.imagen"
                                  v-if="person.imagen"
                                ></v-img>
                                <v-icon color="#a7ba38" v-else
                                  >mdi-account</v-icon
                                >
                              </v-list-item-avatar>
                              <v-list-item-content>
                                <v-list-item-title
                                  v-text="person.Nombres"
                                ></v-list-item-title>
                                <v-list-item-subtitle v-text="person.tipo_usuario == 'alumno' && person.alumno.descripcion !== 'null' ? person.alumno.descripcion : ''">

                                </v-list-item-subtitle>
                              </v-list-item-content>
                              <v-list-item-icon>
                                <v-icon 
                                  >mdi-chevron-right</v-icon
                                >
                              </v-list-item-icon>

                              
                            </v-list-item>
                          </div>
                          <v-divider></v-divider>
                        </div>
                      </v-list-item-group>
                    </v-list>
                  </v-card>
                </v-col>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>
<script>
import moment from "moment";
moment.locale('es')
export default {
name: "Publication",
    components: {},
    props:{
        showDialog: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
      textSearchContact: "",
      current_page_contacts: 0,
      contacts: [],
      //usuarioBorrado: ''
    }),
    watch: {
        showDialog (val) {
            
            if(!val){
              this.$emit('updatepublication', val)
            }
            
        }
    },
    methods: {
      
        openProfile(id,tipo_usuario){
            this.$router.push('profile/'+id+'/'+tipo_usuario);  
        },
        cancelSearch() {
            this.textSearchContact = "";
            this.loadContacts();
        },
        async loadContacts(reload = true) {
        if(this.textSearchContact.length >= 2){
            //this.loading = true;
            this.current_page_contacts++;
            let urlSearch = this.textSearchContact
            ? "&search=" + this.textSearchContact
            : "";
            this.$API
            .get({
                  url:
                    "contacts?paginate=1&page=" +
                    this.current_page_contacts +
                    urlSearch,
                })
                .then((res) => {
                  //this.loading = false;
                  if (reload) {
                    this.contacts = res;
                    console.log(res)
                    this.current_page_contacts = 0;
                  } else {
                    this.contacts = { ...this.contacts, ...res };
                  }
            });
        }
          
        },
        handleScrollContacts(el) {
          if (
            el.target.offsetHeight + el.target.scrollTop >=
            el.target.scrollHeight
          ) {
            this.loadContacts(false);
          }
        },
      
    },
    computed: {
      user() {
        return this.$store.getters.user;
      },
      contactsFiltered() {
          if (this.textSearchContact) {
            return this.contacts;
          } else {
            return this.contacts;
          }
        },
    },
    mounted() {
      //this.usuarioBorrado = this.user.borrado;
    }
};
</script>

